import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { getDetailDiscount } from "../../api/requestAxios/discounts";
import { ToPersianNumber, DateToPersianNumber } from "../../functions/index";
import { ErrorToast, Loading, NotLogin } from "../../shared";
import GSPTable from '../../shared/GSFTable'
import Action from "./action";

const Promption = () => {

    const location = useLocation()

    useEffect(() => {
        getDetails(location?.state?.id)
    }, [location])

    const [details, setDetails] = useState({ data: [] })
    const [loading, setLoading] = useState(true);

    const discountPercentCompo = ({ item }) => {
        return (item?.discountPercent ? ToPersianNumber(item?.discountPercent) : "۰")
    }
    const maxDiscountAmountCompo = ({ item }) => {
        return (item?.maxDiscountAmount ? ToPersianNumber(item?.maxDiscountAmount) : 'نامحدود')
    }
    const applicationLimitCountCompo = ({ item }) => {
        return (item?.applicationLimitCount ? ToPersianNumber(item?.applicationLimitCount) : 'نامحدود')
    }
    const appliedCountCompo = ({ item }) => {
        return (item?.appliedCount !== 0 ? ToPersianNumber(item?.appliedCount) : "۰")
    }
    const totalAppliedAmountCompo = ({ item }) => {
        return (item?.totalAppliedAmount !== 0 ? ToPersianNumber(item?.totalAppliedAmount) : "۰")
    }
    const persianStartDateCompo = ({ item }) => {
        return (item?.persianStartDate ? DateToPersianNumber(item?.persianStartDate.substring(0, 10)) : '---')
    }
    const persianEndDateCompo = ({ item }) => {
        return (item?.persianEndDate ? DateToPersianNumber(item?.persianEndDate.substring(0, 10)) : '---')
    }

    const productNameCompo = ({ item }) => {
      
            return (
            <>
                {(!item?.productLimitation ||  (!item?.productLimitation?.some(x=>x.allProducts===false) && item?.productLimitation.length===4))?
                    <span> همه‌ی سرویس‌ها</span> :
                    <>
                        {item?.productName?.length > 0 && item?.productName?.map(element => {
                            return (
                                <div>

                                    <span>
                                        {element}
                                    </span>
                                    <hr />
                                </div>
                            )
                        })}

                        {item?.productLimitation?.length > 0 && item?.productLimitation?.map((_elm) => {
                            if (_elm?.allProducts) {
                                return (
                                    <div>

                                        <span>
                                            {_elm?.productType === "Secretary" && "همه ی سرویس های منشی"}
                                            {_elm?.productType === "IVR" && "همه ی سرویس ها تلفن گویا"}
                                            {_elm?.productType === "Line" && "همه‌ی سرویس‌های خط"}
                                            {_elm?.productType === "Fax" && "همه ی سرویس های فکس"}
                                        </span>
                                        <hr />
                                    </div>
                                )
                            }
                        })
                        }
                    </>
                }

            </>
        )
    }

    const purchaseLimitCompo = ({ item }) => {
        return (
            item?.purchaseLimit?.length > 0 ?
                item?.purchaseLimit?.map(element => {
                    return (
                        <div>
                            <span>
                                {element === 1 && "همه"}
                                {element === 2 && "اولین خرید"}
                                {element === 3 && "تمدید سرویس"}
                                {element === 4 && "مشترکین بازگشتی"}
                            </span>
                        </div>
                    )
                }) :
                <span>----</span>
        )
    }

    const contractTypeLimitsCompo = ({ item }) => {
        return (
            item?.contractTypeLimits?.length > 0 ?
                item?.contractTypeLimits?.map(element => {
                    return (
                        <div>
                            <span>
                                {element === 1 && "همه"}
                                {element === 2 && "یک ماهه"}
                                {element === 3 && "سه ماهه"}
                                {element === 4 && "شش ماهه"}
                                {element === 5 && "یک ساله"}
                            </span>
                        </div>
                    )
                }) :
                <span>----</span>
        )
    }

    const columns = [
        { title: 'درصد', property: 'discountPercent', component: discountPercentCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'سقف مبلغ', property: 'maxDiscountAmount', component: maxDiscountAmountCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'سقف تعداد', property: 'applicationLimitCount', component: applicationLimitCountCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'تعداد استفاده', property: 'appliedCount', filterProperty: null, component: appliedCountCompo, hasSort: false, hasFilter: false, display: true },
        { title: 'مبلغ استفاده', property: 'totalAppliedAmount', filterProperty: null, component: totalAppliedAmountCompo, hasSort: false, hasFilter: false, display: true },
        { title: 'نوع سرویس', property: 'productName', filterProperty: null, component: productNameCompo, hasSort: false, hasFilter: false, display: true },
        { title: 'نوع مشترکین', property: 'purchaseLimit', filterProperty: null, component: purchaseLimitCompo, hasSort: false, hasFilter: false, display: true },
        { title: 'مدت قرارداد', property: 'contractTypeLimits', filterProperty: null, component: contractTypeLimitsCompo, hasSort: false, hasFilter: false, display: true },
        { title: 'تاریخ ایجاد', property: 'persianStartDate', component: persianStartDateCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'تاریخ انقضا', property: 'persianEndDate', component: persianEndDateCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
    ]

    const getDetails = async (id) => {
        try {
            setLoading(true);
            const discountDetail = await getDetailDiscount(id)
            setLoading(false);
            let temp = { ...details }
            temp.data = [discountDetail?.data]
            setDetails({ ...temp });
        }
        catch (err) {
            setLoading(false);
            ErrorToast(err)
        }
    }


    return (
        <main>
            {!location?.state?.login ? (
                <NotLogin></NotLogin>
            ) : loading ? (
                <Loading></Loading>
            ) : (
                <>
                    <div className="top-margin"></div>
                    <div className="user-info-container user-docs-container user-service-container mb-5 pb-5">
                        <div className="user-info">
                            <Action
                                details={details?.data[0]}
                                usable={location?.state?.usable}
                                login={location?.state?.login}
                            />
                            <hr />
                            <h2>مشخصات کد</h2>

                            <GSPTable
                                columns={columns}
                                hasSorting={false}
                                dataList={details}
                                hasFiltering={false}
                                isSearchByExternalBtn={false}
                                hasPaging={false}
                                enableScrolling={false}
                                isStepScrolling={false}
                            />
                        </div>
                    </div>
                </>
            )}
        </main>








    )
}
export default Promption